import { usePage } from '@inertiajs/vue3'

export const useCompanyPermissions = () => {
  const page = usePage()

  const permissions = page.props.auth.company_permissions

  return {
    permissions,
    userCan: (permission) => permissions.includes(permission)
  }
}
